module.exports = __webpack_public_path__ + "img/symbol_1.3665d956.png";